import { FaStopwatch, FaTrophy } from 'react-icons/fa';
import { useSudoku } from '../../../../Sudoku/SudokuContext';
import { useTimerContext } from '../../../../../hooks/TimerContext';

import Switch from '../../../../../components/SwitchTheme';

import { Button, Container, Content, Footer, Header } from './styles';
import { IoTriangleSharp } from 'react-icons/io5';
import { useThemeApp } from '../../../../../hooks/theme';

import wordleIcon from '../../../../../assets/icons/wordle-icon.png';

interface ItemMenuProps {
  buttonText: string;
  buttonFunctions?: () => void;
}

interface SidebarProps {
  maxScore: number;
  menuItems: ItemMenuProps[];
  currentScore: number;
  children: JSX.Element;
}

interface GameTypeProps {
  name: string;
  headerColor: string;
  hoverColor: string;
  darkHoverColor: string;
  counterColor: string;
  darkCounterColor: string;
  icon: string;
  bottomColor?: string;
}

export const Sidebar = ({
  maxScore,
  menuItems,
  currentScore,
  children,
}: SidebarProps) => {
  const { minutes, seconds } = useTimerContext();
  const { score } = useSudoku();

  const { isDark } = useThemeApp();

  const gamesProps: GameTypeProps = {
    name: 'WORDLE',
    headerColor: '#d6d6d6',
    hoverColor: '#D1A14C',
    darkHoverColor: '#D1A14C',
    counterColor: '#000',
    darkCounterColor: '#000',
    icon: wordleIcon,
  };

  return (
    <Container>
      <Header
        counterColor={
          isDark ? gamesProps.darkCounterColor : gamesProps.counterColor
        }
        headerColor={gamesProps.headerColor}
      >
        <p>
          <img src={gamesProps.icon} alt="Game Icon" />
          {gamesProps.name}
        </p>
        <span>
          <p>
            <FaStopwatch size={20} />
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </p>
          <p>
            <FaTrophy size={20} />
            {currentScore === -1 ? score : currentScore}/{maxScore} PTS
          </p>
        </span>
      </Header>
      <Content>
        {menuItems.map((item) => (
          <Button
            hoverColor={
              isDark ? gamesProps.darkHoverColor : gamesProps.hoverColor
            }
            key={item.buttonText}
            onClick={item.buttonFunctions}
          >
            <p>{item.buttonText}</p>
          </Button>
        ))}
      </Content>
      <div className="keyboard">{children}</div>
      <Footer
        isDark={isDark}
        backgroundColor={
          gamesProps.bottomColor
            ? gamesProps.bottomColor!
            : gamesProps.headerColor
        }
      >
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Switch />
        </div>
        <p>
          VER MAIS COMENTÁRIOS <IoTriangleSharp size={12} />
        </p>
      </Footer>
    </Container>
  );
};
